import { FC, ReactElement, useState } from 'react';

import type { UploadFile } from 'antd';
import { Upload } from 'antd';

import useErrorCatch from 'hooks/useErrorCatch';

import { uploadFile } from 'utils/uploadFile';

import { AttachmentTypes } from 'types/api';

import { GlobalModules } from 'constants/enums';

import { ReactComponent as FileIcon } from 'assets/icons/file.svg';
import { useTranslation } from 'react-i18next';

interface UploadFileWithButtonProps {
  allowedFileTypes: string;
  attachmentType: AttachmentTypes;
  ownerId: string;
  onAddFile: () => void;
  module?: GlobalModules;
  childId?: string;
  onUploadStart?: () => void;
  onUploadEnd?: () => void;
  isEditable?: boolean;
}

const MAX_FILES_COUNT = 1;

const UploadFileWithButton: FC<UploadFileWithButtonProps> = ({
  allowedFileTypes,
  attachmentType,
  ownerId,
  onAddFile,
  onUploadStart,
  onUploadEnd,
  isEditable = false,
  module = GlobalModules.ClientsAndJobsModule,
  childId
}): ReactElement => {
  const { t } = useTranslation()
  const [isDisabled, setIsDisabled] = useState(!isEditable);
  const catchError = useErrorCatch();

  const { Dragger } = Upload;

  const handleBeforeUpload = (file: UploadFile): boolean => {
    uploadFile({
      module,
      file,
      attachmentType,
      ownerId,
      childId,
      onAddFile,
      setIsDisabled,
      catchError,
      onUploadStart,
      onUploadEnd,
      isEditable,
      translate: t
    });

    return false;
  };

  return (
    <div className="upload-button-container upload-file-with-button">
      <Dragger
        fileList={[]}
        beforeUpload={handleBeforeUpload}
        accept={allowedFileTypes}
        maxCount={MAX_FILES_COUNT}
        iconRender={() => <FileIcon />}
        disabled={isDisabled || !isEditable}
      >
        <span>{t('common.uploadFile.button')}</span>
      </Dragger>
    </div>
  );
};

export default UploadFileWithButton;
